import * as React from 'react';
import { observer, inject } from "mobx-react";
import { Button, TextField, FormControlLabel, Checkbox } from '@material-ui/core';

// =====================================
// STORES
import { ILoginStore } from '../../store/loginStore';

// =====================================
// COMPONENTS
import { Header } from '../Layout/Header';
import { Loader } from '../Layout/Loader';
import { ErrorMessage } from '../Layout/ErrorMessage';

interface ILogin {
    loginStore?: ILoginStore
}

@inject((allStores: any) => ({
    loginStore: allStores.store.loginStore as ILoginStore
}))

@observer
export default class Login extends React.Component<ILogin, any> {

    componentDidMount() {
        this.props.loginStore.init("login");
    }

    componentWillUnmount() {
        this.props.loginStore.reset();
    }

    render() {
        return (
            <div className="login-container">
                <Header
                    title="Ulogujte se"
                    isBackButtonVisible={true}
                    samePageAction={this.props.loginStore.onSignOut} />

                <div id="recaptcha-container"></div>

                {!this.props.loginStore.isLoading ?
                    <>
                        <h2 className="welcome-title">Ulogujte se sa vašim brojem telefona</h2>
                        <div className="container">
                            {this.props.loginStore.isPhoneNumberFormVisible
                                ? <div>
                                    <form noValidate autoComplete="off" className="login-form">
                                        <TextField
                                            id="phone-number"
                                            label="Broj telefona (06x-xxx-xxxx)"
                                            type="number"
                                            name="phoneNumber"
                                            className="phone-number-input"
                                            value={this.props.loginStore.phoneNumber}
                                            onChange={this.props.loginStore.onHandleChangeInput} />
                                        <ErrorMessage>
                                            {this.props.loginStore.phoneNumberMessage}
                                        </ErrorMessage>
                                        <Button
                                            variant="contained"
                                            color="default"
                                            size="small"
                                            className="btn-login"
                                            onClick={this.props.loginStore.onSignInWithPhoneNumber}
                                        > Verifikujte vaš broj
                                        </Button>
                                    </form>
                                </div> : null
                            }

                            {this.props.loginStore.isCodeFormVisible
                                ? <div>
                                    <form noValidate autoComplete="off" className="login-form">
                                        <TextField
                                            id="code-number"
                                            label="Verifikacioni kod"
                                            type="number"
                                            name="code"
                                            className="phone-number-input"
                                            value={this.props.loginStore.code}
                                            onChange={this.props.loginStore.onHandleChangeInput} />
                                        <ErrorMessage>
                                            {this.props.loginStore.codeMessage}
                                        </ErrorMessage>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={this.props.loginStore.rememberMe}
                                                    onChange={this.props.loginStore.handleChangeRememberMe}
                                                    name="checkedB"
                                                    color="primary" />
                                            }
                                            label="Zapamti me"
                                            className="form-checkbox"
                                        />
                                        <Button
                                            variant="contained"
                                            color="default"
                                            size="small"
                                            className="btn-login"
                                            onClick={this.props.loginStore.onSubmitCode}
                                        > Ulogujte se
                                        </Button>
                                    </form>
                                </div> : null
                            }

                            {this.props.loginStore.showWithdrawFromTheOrganizationButton
                                ? <div>
                                    <Button
                                        variant="contained"
                                        color="default"
                                        size="small"
                                        className="btn-login"
                                        onClick={this.props.loginStore.withdrawFromTheOrganization}
                                    > Istupi iz organizacije
                                        </Button>
                                </div> : null
                            }
                        </div>
                    </> : <Loader />}
            </div>
        );
    }
}